import './index.css'

import React from 'react'
import ReactDOM from 'react-dom'
import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";

import App from './App'
import AppRendaFixa from './AppRendFixa'
import AppJurosCompostos from './AppJurosCompostos'

let tag;

if (document.currentScript.getAttribute('targetid')) {
    tag = document.getElementById(document.currentScript.getAttribute('targetid'))
} else {
    tag = document.getElementById('calc-juros-compostos')
}

switch (tag.getAttribute('calc')) {
    case 'juros-compostos':
        ReactDOM.render(<AppJurosCompostos title={tag.dataset.title} subtitle={tag.dataset.subtitle}/>, tag)
        break;
    case 'renda-fixa':
        ReactDOM.render(<AppRendaFixa title={tag.dataset.title} subtitle={tag.dataset.subtitle}/>, tag)
        break;
    default:
        ReactDOM.render(
            <BrowserRouter>
                {/* <App title={tag.dataset.title} subtitle={tag.dataset.subtitle}/> */}
                <Routes>
                    <Route path="/utils" element={<App title={tag.dataset.title} subtitle={tag.dataset.subtitle}/>} />
                    <Route path="/utils/calculadora-juros-compostos" element={<AppJurosCompostos title={tag.dataset.title} subtitle={tag.dataset.subtitle}/>} />
                    <Route path="/utils/calculadora-renda-fixa" element={<AppRendaFixa title={tag.dataset.title} subtitle={tag.dataset.subtitle}/>} />
                </Routes>
            </BrowserRouter>
        , tag)
        break;
}
// ReactDOM.render(<App title={tag.dataset.title} subtitle={tag.dataset.subtitle}/>, tag)
